import $ from "jquery";
//
import { Echangeur } from "./Echangeur";

//
//
var logger = {};
//
let errorSelector = $("#erreur").toggle(false);

logger.log = function (message) {
  errorSelector
    .toggle(true)
    .addClass("show")
    .children("div")
    .first()
    .text(message);
};
logger.empty = function () {
  errorSelector
    .removeClass("show")
    .toggle(false)
    .children("div")
    .first()
    .empty();
};
errorSelector
  .children("button")
  .first()
  .on("click", function () {
    logger.empty();
  });
$(window).on("hashchange", function () {
  logger.empty();
});

function valeurFonction(f, p) {
  if (typeof f === "function") return f(p); // if ($.isFunction(f)) return f(p); $.isFunction deprecated
  return f;
}

class MiniFormulaire {
  constructor(h) {
    this.hash = null;
    //
    this.$c = {}; // conteneur
    this.retour = null; // fonction de retour ;
  }
  toggle(value) {
    this.$c.toggle(value);
  }
  /**
   * @param  {any} conteneur jquery selector
   * @return {MiniFormulaire} this
   */
  initialise(conteneur) {
    if (!conteneur) throw "initialise sans conteneur";
    this.$c = $(conteneur);
    this.toggle(false);
    return this;
  }
  onBlur(echangeur) {}
  onFocus(echangeur) {}

  async demarre(pHash, retour, echangeurSource) {
    this.retour = retour;
    this.hash = pHash;
    var echangeur = echangeurSource || new Echangeur();
    echangeur.name = "getData";
    echangeur.hash = pHash;
    await this.load(echangeur);
    return this;
  }
  url(echangeur) {}
  async load(echangeur) {
    //
    this.url(echangeur); // Chargement des actions
    //
    await echangeur.runAsync();
    if (echangeur.erreur) {
      this.onError("Erreur JSON", echangeur.erreur.message, echangeur);
    } else {
      await this.loader(echangeur); // Affichage du contenu
      this._onFirstLoad(echangeur); // Affichage du contenu. Une seule fois
      if (this.title) {
        document.title = valeurFonction(this.title, echangeur);
      }
      //
      this.toggle(true); // affichage de l'écran
      //
      await this.onLoad(echangeur);
      this.onFocus(echangeur);
    }
  }
  //
  async onLoad(echangeur) {}
  //
  // Déclenchée une seule fois pour activer les clicks sur les boutons
  _onFirstLoad(echangeur) {
    var isNotSet = this.$c.attr("data-i") ? false : true;
    if (isNotSet) {
      this.$c.attr("data-i", "I");
      if (this.onFirstLoad) this.onFirstLoad(echangeur);
    }
  }
  onFirstLoad(echangeur) {}

  fin(echangeur) {
    if (this.onBlur) this.onBlur(echangeur);
    this.toggle(false);
    if (this.retour) this.retour(echangeur);
  }
  async loader(p) {}

  onError(etat, message, p) {
    logger.log(message || p);
  }

  /**
   * @param  {String} expression du champ
   * @return {Object} field
   */
  c$(expression) {
    return $(expression, this.$c);
  }

  /**
   * Rempli le html et le js d'un miniformulaire à partir d'un objet {html,js}
   * @param  {{html,js}} formulaire
   * @return {MiniFormulaire} this
   */
  fillImport(formulaire) {
    this.$c.html(formulaire.html);
    var u = formulaire.js;
    for (var a in u) this[a] = u[a];
    return this;
  }
  async rest(fonction, parametres, doc, d) {
    let data = null;
    try {
      data = await Echangeur.rest(fonction, parametres, doc, d);
    } catch (e) {
      this.onError("?", e.message, e);
    }
    return data;
  }
}

export default MiniFormulaire;
